

export { PredicateList } from './src/index';
export { SelectorPredicate } from './src/selector-predicate.es';
export { PredicateVM } from './src/viewmodel/predicate.es';
